package com.ervasstudio.tracoemovimento.components.sections

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.layouts.PdfSecction
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors.Black
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import org.jetbrains.compose.web.css.cssRem


@Composable
fun Footer(
    isHome: Boolean = false,isMobile: Boolean
) {
    Column(modifier = Modifier.fillMaxWidth()) {
        Row(
            modifier = Modifier.fillMaxWidth().margin(top = if (isHome)0.cssRem else 4.cssRem).padding(top = 4.cssRem, bottom = 4.cssRem, leftRight = 3.cssRem)
                .backgroundColor(Black),

            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically,
        ) {
            if (!isHome && !isMobile) {
                PdfSecction(isMobile)
            }else{
                if(!isHome) PdfSecction(ismobile = isMobile)
            }

        }
        when (isHome) {
            true -> {}
            false -> {
                Logos(isHome, isMobile)
            }
        }

    }


}